<i class="fas fa-sun text-3xl self-center"></i>
<div class="space-y-1">
	<div class="font-semibold text-lg">
		{{ controller.i18n + '.descriptionHeaderElement.text' | translate }}
	</div>
	<div>{{ controller.i18n + '.descriptionElement.text' | translate }}</div>
</div>
<form [formGroup]="controller.moodDescriptionForm" class="space-y-1">
	<div class="font-semibold text-lg">
		{{ controller.i18n + '.frequencyHeaderElement.text' | translate }}
	</div>
	<p-dropdown
		[options]="controller.frequencyOptions$ | ngrxPush"
		appendTo="body"
		formControlName="frequency"
		styleClass="w-full"
	></p-dropdown>
</form>
<div class="flex justify-end items-center space-x-3">
	<p-button
		[label]="controller.i18n + '.cancelButton.label' | translate"
		(onClick)="onCancelClick()"
		styleClass="p-button-primary-inverse"
	></p-button>
	<p-button
		[label]="controller.i18n + '.startButton.label' | translate"
		(onClick)="onStartClick()"
	></p-button>
</div>
